// extracted by mini-css-extract-plugin
export default {"checkbox":"YXItz4","checkbox--disabled":"uCllyI","checkboxDisabled":"uCllyI"};